<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-3 pa-6" outlined tile>
          <h3>Test</h3>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'Home',
  components: {
  }
}
</script>
